import OffScreen from "../../../../common/core-ui/OffScreen";
import useContentResults from "../results/useContentResults";
import useTitleResults from "../results/useTitleResults";
import { FormattedMessage } from "react-intl";
import MountAfterDelay from "../../../../common/core-ui/MountWithDelay";

export default function SearchAnnouncer({
  titleResults,
  contentResults,
  query,
  noResults,
  resultsReady,
}: {
  titleResults: ReturnType<typeof useTitleResults>;
  contentResults: ReturnType<typeof useContentResults>;
  query: string;
  noResults: boolean;
  resultsReady: boolean;
}) {
  const resultsMessage = () => {
    const titleCount =
      titleResults.allResults.totalItems +
      titleResults.licenseResults.items.length;
    const contentCount = contentResults.allResults.length;

    if (
      titleResults.status === "has-results" &&
      contentResults.status === "has-results"
    ) {
      return (
        <FormattedMessage
          defaultMessage="{titleCount, plural, =1 {1 Result} other {{titleCount} Results}} found in Titles and {contentCount, plural, =1 {1 Result} other {{contentCount} Results}} found in Book Content"
          values={{ titleCount, contentCount }}
        />
      );
    }

    if (
      titleResults.status === "has-results" &&
      contentResults.status === "empty"
    ) {
      return (
        <FormattedMessage
          defaultMessage="{titleCount, plural, =1 {1 Result} other {{titleCount} Results}} found in Titles"
          values={{ titleCount }}
        />
      );
    }

    if (
      titleResults.status === "empty" &&
      contentResults.status === "has-results"
    ) {
      return (
        <FormattedMessage
          defaultMessage="{contentCount, plural, =1 {1 Result} other {{contentCount} Results}} found in Book Content"
          values={{ contentCount }}
        />
      );
    }
  };

  const announcement = () => {
    if (noResults) {
      return (
        <FormattedMessage
          defaultMessage="We couldn’t find a match for “{query}”"
          values={{ query }}
        />
      );
    }

    if (resultsReady) {
      return resultsMessage();
    }

    return (
      <MountAfterDelay timeout={100}>
        <FormattedMessage defaultMessage="Loading Results" />
      </MountAfterDelay>
    );
  };

  return <OffScreen role="status">{announcement()}</OffScreen>;
}
